<template>
    <div v-if="modelValue && modelValue.length > 0" class="alert alert-danger text-white mb-0 p-2 pr-3 show-error-panel">
        <p class="mb-1">به موارد زیر توجه فرمایید</p>
        <ul class="mb-2">
            <li v-for="error in modelValue" :key="error.$uid" class="mb-0 error-item">
               {{error.$message}}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "show-errors",
        props: ["modelValue"],
        data() {
            return {
            }
        },
        computed: {
        },
        watch:
        {
        //    modelValue: {
        //        handler: function (newItem, oldItem) {
        //            debugger
        //        },
        //        deep: true
        //    }
        },
        methods:
        {
        },
        mounted() {
        }
    };
</script>
